module.exports = __webpack_public_path__ + "img/socialmediabgc.d586c954.png";